import _ from 'lodash';
import { List } from 'immutable';

import FeatureFlagStore from '../stores/FeatureFlagStore';
import APIClient, { NotFoundError } from '../lib/APIClient';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import Railcard from '../records/Railcard';
import AccountRailcard from '../records/AccountRailcard';
import { resolve, resolveAll } from '../helpers/LinkMapper';

const dataUrl = '/data/railcards';
const railcardCache = {};

let RailcardsService = {

    getBaseUrl(user) {
        return `/customers/${user.id}`;
    },

    getRailcardCodesQuery(filterRailcardCodes) {
        return filterRailcardCodes.length ? `&railcardCode=${filterRailcardCodes.join('&railcardCode=')}` : '';
    },

    get(code) {
        if (railcardCache[code]) {
            return railcardCache[code];
        }

        railcardCache[code] = APIClient.get(dataUrl + '/' + code)
            .then((response) => {
                if (response.result) {
                    return resolve({ ...response.result, id: dataUrl + '/' + code}).as(Railcard);
                }
                return new Railcard();
            })
            .catch((error) => {
                if (error instanceof NotFoundError) { return new Railcard(); }
                delete railcardCache[code];
                throw error;
            });

        return railcardCache[code];
    },

    getAll(options) {
        return APIClient.get('/config/railcards', options).then(response => {
            const railcards = _.map(response.result, 'railcard');
            if (!FeatureFlagStore.get('enableRailcardVeterans')) {
                return resolveAll(railcards).as(Railcard).filter(railcard => railcard.get("code") !== "VET");
            } else {
                return resolveAll(railcards).as(Railcard);
            }
        });
    },

    getAccountDRC(userId) {
        return AuthenticatedAPIClient.get(`/digital-railcards/${userId}/railcards`);
    },

    setFavouriteDRC(userId, railcardId) {
        return AuthenticatedAPIClient.put(`/digital-railcards/${userId}/railcards/${railcardId}/favourite`);
    },

    removeDRCDevice(userId, railcardId, body) {
        return AuthenticatedAPIClient.delete(`/digital-railcards/${userId}/railcards/${railcardId}/device`, body);
    },

    getAccountRailcards(user, filterRailcardCodes = []) {
        return AuthenticatedAPIClient.get(`${this.getBaseUrl(user)}/railcards?state=ACCEPTED&state=PENDING${this.getRailcardCodesQuery(filterRailcardCodes)}`)
            .then(response => {
                const railcards = response.result.map(railcard => ({
                    ...railcard,
                    railcardName: response.links[railcard.railcardCode].name
                }));
                return resolveAll(railcards).as(AccountRailcard);
            }).catch(() => new List());
    },

    seenApprovedRailcards(user, accountRailcardsIds) {
        return AuthenticatedAPIClient.put(`${this.getBaseUrl(user)}/railcards`, { railcards: accountRailcardsIds });
    },

    seenSyncKeyGoNotification(user, accountRailcardsIds) {
        return AuthenticatedAPIClient.put(`${this.getBaseUrl(user)}/season-railcards`, { railcards: accountRailcardsIds });
    },

    submitRailcardApplication(user, data, files) {
        return AuthenticatedAPIClient.postForm(`${this.getBaseUrl(user)}/railcards`, data, files);
    },

    deleteAccountRailcard(user, railcard) {
        return AuthenticatedAPIClient.delete(`${this.getBaseUrl(user)}/railcards/${railcard.id}`);
    },

};

export default RailcardsService;
